<template>
	<v-container class="mx-auto">
		<v-layout row wrap align-center>
			<v-card class="mx-auto outer-container" width="100%" max-height="100%">
				<v-row>
					<v-col
						class="col-md-6 col-sm-12 pa-0 ma-0 ml-n2 mr-2 d-none d-md-block"
						align="center"
						justify="center"
						:elevation="10"
					>
						<v-img
							width="100%"
							height="100%"
							class="white--text ml-5 big-card-image"
							src="../assets/help.svg"
						>
						</v-img>
					</v-col>

					<v-col class="col-md-6 pa-5">
						<div class="mx-4">
							<h4 class="mb-2 mt-4">FAQs</h4>
							<v-subheader class="ml-0 pl-0 mt-2"
								>How do I update my profile?</v-subheader
							>
							<div class="font-under-normal">
								To update your profile, navigate to the
								<a
									link
									class="text-decoration-none"
									href="profile"
									@click="router.push({ name: 'Profile' })"
									>Profile page</a
								>
								and click on the <strong>Edit Profile</strong> button.
							</div>

							<v-subheader class="ml-0 pl-0 mt-2"
								>How do I increase my star progress?</v-subheader
							>
							<div class="font-under-normal">
								Your star progress is generated from your activity on the
								platform. To become a LEGEND, study more courses and take more
								quizzes. <br />Pro tip: Getting a high score in quizzes gives
								you bonus stars
							</div>

							<v-subheader class="ml-0 pl-0 mt-2"
								>What is Keepaway?</v-subheader
							>
							<div class="font-under-normal">
								Keepaway is a social distancing measure added in to combat the
								COVID-19 pandemic. This can also be used for other relevant
								distancing scenarios.
							</div>

							<h4 class="mt-5">I have other questions</h4>
							<div class="font-under-normal pt-1">
								Please for any other questions, contact us via any of the
								following
							</div>
							<div class="mt-2">
								<v-subheader class="ml-0 pl-0">Email</v-subheader>
								<a
									href="mailto:P2549553@my365.dmu.ac.uk"
									class="text-decoration-none font-under-normal"
								>
									P2549553@my365.dmu.ac.uk
								</a>

								<!-- <v-subheader class="ml-0 pl-0">Phone</v-subheader>
									<a href="/" class="text-decoration-none font-under-normal">
										07438055783
									</a> -->

								<v-subheader class="ml-0 pl-0 mt-2">Social media</v-subheader>
								<v-row class="ma-0 pa-0">
									<div class="col-md-6 col-sm-6 px-0">
										<v-hover>
											<template v-slot="{ hover }">
												<v-btn
													:class="`elevation-${hover ? 12 : 1}`"
													width="160"
													color="white"
													dark
													class="rounded-lg py-5 px-4 text-capitalize mt-2 transition-swing "
													small
													target="_blank"
													href="https://fb.com/itzenoch.oconnell"
												>
													<v-icon class="mr-2 fb">mdi-facebook</v-icon>
													<span class="fb">Enoch Banjo</span>
												</v-btn>
											</template>
										</v-hover>
									</div>

									<div class="col-md-6 col-sm-6 px-0">
										<v-hover>
											<template v-slot="{ hover }">
												<v-btn
													:class="`elevation-${hover ? 12 : 1}`"
													width="160"
													color="white"
													dark
													class="rounded-lg py-5 px-4 text-capitalize mt-2 transition-swing "
													small
													target="_blank"
													href="https://www.instagram.com/trigga_gfx"
												>
													<v-icon class="mr-2 ig">mdi-instagram</v-icon>
													<span class="ig">@trigga_gfx</span>
												</v-btn>
											</template>
										</v-hover>
									</div>

									<div class="col-md-6 col-sm-6 px-0">
										<v-hover>
											<template v-slot="{ hover }">
												<v-btn
													:class="`elevation-${hover ? 12 : 1}`"
													width="160"
													color="white"
													dark
													class="rounded-lg py-5 px-4 text-capitalize mt-2 transition-swing "
													small
													target="_blank"
													href="https://twitter.com/enochbanjo"
												>
													<v-icon class="mr-2 tw">mdi-twitter</v-icon>
													<span class="tw">@enochbanjo</span>
												</v-btn>
											</template>
										</v-hover>
									</div>

									<div class="col-md-6 col-sm-6 px-0">
										<v-hover>
											<template v-slot="{ hover }">
												<v-btn
													:class="`elevation-${hover ? 12 : 1}`"
													width="160"
													color="white"
													dark
													class="rounded-lg py-5 px-4 text-capitalize mt-2 transition-swing "
													small
													target="_blank"
													href="https://snapchat.com/add/enoch_gx"
												>
													<v-icon class="mr-2 sc">mdi-snapchat</v-icon>
													<span class="sc">@enoch_gx</span>
												</v-btn>
											</template>
										</v-hover>
									</div>
								</v-row>
							</div>
						</div>
					</v-col>
				</v-row>
			</v-card>
		</v-layout>
	</v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
	name: 'HelpCenter',

	data: () => ({}),

	methods: {
		...mapMutations([]),
	},

	mounted() {},

	computed: {
		...mapGetters([]),
	},
}
</script>

<style scoped>
.fb {
	color: #3b5998 !important;
}
.ig {
	color: #e1306c !important;
}
.tw {
	color: #00acee !important;
}
.sc {
	color: #000000 !important;
}
</style>
